<style>
</style>
<template>
<div>
  <v-tooltip bottom v-if="item.isCanceled">
    <template v-slot:activator="{ on }">
    <v-icon color="red" v-on="on">cancel</v-icon>
  </template>
  <span>{{ $t('Zrušeno') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-else-if="item.isUsed">
    <template v-slot:activator="{ on }">
    <v-icon color="green" v-on="on">check</v-icon>
  </template>
  <span>{{ $t('Využito') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-else-if="isPast(item)">
    <template v-slot:activator="{ on }">
    <v-icon color="red" v-on="on">timer</v-icon>
  </template>
  <span>{{ $t('Prošlé') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-else>
    <template v-slot:activator="{ on }">
    <v-icon color="green" v-on="on">exit_to_app</v-icon>
  </template>
  <span>{{ $t('Aktivní') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-if="item.canCancel && !willCanceled(item)">
    <template v-slot:activator="{ on }">
    <v-icon color="red" @click.native="expanded.length > 0 && expanded[0] === item ? expanded = [] : expanded = [item]" @click="cancelReservation(item)" v-on="on">delete</v-icon>
  </template>
  <span>{{ $t('Zrušit rezervaci') }}</span>
  </v-tooltip>
</div>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin.js'
const moment = require('moment')

export default {
  mixins: [BasketMixin],
  props: {
    expanded: {
      type: Array,
      default() {
        return []
      }
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    isPast(item) {
      return moment().diff(item.sample.validTo) > 0
    },
    willCanceled(item) {
      return this.basket.items && this.basket.items.find(i => i.reservation && i.reservation.reservationId === item.sample.reservation.reservationId &&
        i.reservation.itemNo === item.sample.itemNo)
    },
    cancelReservation(item) {
      this.putReservations([{ cardId: item.card.cardId, removeFlag: true, reservationId: item.sample.reservation.reservationId, itemNo: item.sample.itemNo }])
    }
  }
}
</script>
